import { Account } from "./account";

export class BuddyRequest {
    buddy: Account;
    rodeoEventId: number;
    buddyTeammate: Account;
    teammateHeader: boolean;
}


// WEBPACK FOOTER //
// ./src/model/buddy-request.ts